const daylightSavingTimeOffset = () => {
    const today = new Date();

    const timezoneOffset = () => {
        const jan = new Date(today.getFullYear(), 0, 1);
        const jul = new Date(today.getFullYear(), 6, 1);

        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    };

    const isDstObserved = (today: Date) => today.getTimezoneOffset() < timezoneOffset();

    if (isDstObserved(today)) {
        return 2;
    }

    return 1;
};

export default daylightSavingTimeOffset;
